import { Navigate } from '~/components/utils/Navigation';

export const RegionHomeRoute: React.FC = () => (
  <Navigate to="/onboarding" replace />
);
